<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ $parent.nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ $parent.nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.$parent.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.$parent.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <table style="border-collapse: collapse" align="center" width="100%">
          <div style="border-top: 1px solid #000" class="formTitle">
            <span class="order_number">订单号</span>
            <span class="Transaction_amount">交易金额</span>
            <span class="Actual_arrival">实际到账</span>
            <span class="Transaction_rate">交易率费</span>
            <span class="Service_Charge">手续费</span>
            <span class="Trading_time">交易时间</span>
            <span class="Transaction_status">交易状态</span>
            <span class="Order_type">订单类型</span>
            <span class="store">门店</span>
            <span class="Merchant">商户</span>
            <span class="agent">代理商</span>

            <!-- <span class="fangjia"  style="text-align:right">金额</span>
            <span style="text-align:left;padding-left:10px;flex:1">备注</span>-->
          </div>
          <div style="border-top: 1px solid #000" v-for="item in preArrivalList" class="preArrival">
            <!-- <div class="preArrivalAll">
              <div>
                <span>{{ item.name }}</span>
              </div>
              <div>
                <span>合计:</span>
                <span>{{ item.allAmount }}</span>
              </div>
            </div>-->
            <div v-for="txnItem in item.txnItemList" class="txnItemList">
              <div v-for="billItem in txnItem.billList" class="PreArrivalItem">
                <!-- 订单号 -->
                <div class="order_number">{{ billItem.accNo }}</div>
                <!-- 交易金额 -->
                <div class="Transaction_amount">{{ billItem.updateTime }}</div>
                <!-- 实际到账 -->
                <div class="Actual_arrival">{{ billItem.hotelTime }}</div>
                <!-- 交易率费 -->
                <div class="Transaction_rate">{{ billItem.operator }}</div>
                <!-- 手续费 -->
                <div class="Service_Charge">{{ billItem.chnName }}</div>
                <!-- 交易时间 -->
                <div class="Trading_time">{{ billItem.chnName }}</div>
                <!-- 交易状态 -->
                <div class="Transaction_status">{{ billItem.chnName }}</div>
                <!-- 订单类型 -->
                <div class="Order_type">{{ billItem.chnName }}</div>
                <!-- 门店 -->
                <div class="store">{{ billItem.chnName }}</div>
                <!-- 商户 -->
                <div class="Merchant">{{ billItem.chnName }}</div>
                <!-- 代理商 -->
                <div class="agent">{{ billItem.chnName }}</div>
                <!-- <div  class="fangjia" style="text-align:right">{{ billItem.amount.toFixed(2) }}</div>
                <div  style="text-align:left;padding-left:10px;flex:1">{{ billItem.remark }}</div>-->
              </div>
 
            </div>
          </div>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 本日预到的宾客表
      // preArrivalList: [
      //   {
      //     accNo
      //   }
      // ],
      // // 记录
      // record: "",
      // room: "",
      // total: "",
      // userName: localStorage.getItem("cname"),
      // allPage: 0,
      // // 查询日期
      // queryDate: "",
      // date: ""
    };
  },
  created() {
    this.$parent.bbmc = "T08.领付交易报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    // this.getPreArrivalList();
    this.queryDate = new Date();
    this.date = this.$moment(this.queryDate).format("YYYY-MM-DD HH:mm:ss");
    this.$parent.closeshow();
    // this.$parent.startTimeShow = true;
    // this.$parent.endTimeShow = true;
    // this.$parent.showXsy = true;
    // this.$parent.showysdw = true;
    // this.$parent.chaxunvib = true;
    this.getData();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getData();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true
        });
      }
    },
    getData() {
      let that = this;
      let parms = {
        // startTime: this.$parent.startDate,
        // endTime: this.$parent.endDate,
        // accNo: this.$parent.ysdw,
        // saleManCode: this.$parent.xsy
      };
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/report/A01", parms).then(res => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.preArrivalList = res.data;
          let list = [];
          if (res.data.txnItemList) {
            res.data.txnItemList.forEach(txnItem => {
              list.push(txnItem.billList);
            });
          }

          this.$store.state.preArrivalList = list;
          this.$store.state.preArrivalName = "T08.领付交易报表";
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    },
    dateChange(data) {
      //
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
  height: 62px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 20px;
}
.formTitle {
  margin-bottom: 0;
  border-bottom: none;
}
.formTitle span {
  width: 100px;
  font-size: 14px;
  font-weight: bold;
}
.formTitle span:nth-child(1) {
  width: 120px;
}
.formTitle span:nth-child(6) {
  width: 140px;
}
.formTitle span:nth-child(9) {
  width: 140px;
}
.formTitle span:nth-child(10) {
  width: 140px;
}
.formTitle span:nth-child(11) {
  width: 140px;
}
.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 12em;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 12em;
  text-align: center;
  border: 1px solid #000;
}
.report {
  margin-bottom: 80px;
  margin-left: 4px;
}

table th {
  text-align: center;
  font-weight: normal;
}
table td {
  text-align: center;
}
.trTitle {
  font-weight: bolder;
  border-bottom: 1px solid #000;
}
.trType {
  font-weight: bolder;
}
.trType .tdFlex > div {
  display: flex;
}
td .topDeshed {
  border-top: 2px dashed #000;
  flex: 1;
  transform: translateY(9px);
}
.preArrival {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.preArrivalAll {
  font-weight: bold;
  display: flex;
  justify-content: space-around;

  border-bottom: 1px solid #000;
}
.preArrivalAll > div {
  width: 120px;
}
.reportTitle {
  display: flex;
  justify-content: space-between;
}
.reportTitle > span {
  display: inline-block;
  width: 100px;
  text-align: center;
  /* background: cornflowerblue; */
  /* margin-right: 5%; */
}
.billItemList > span {
  display: inline-block;
  width: 100px;
  text-align: center;
  /* background: darkcyan; */
  /* margin-right: 5%; */
}

.txnItemList > div:first-child {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* border-bottom: 1px solid #000; */
}
/* .txnItemList > div > span {
  display: flex;
  width: 10%;
  text-align: center;
} */
.txnItemall {
  font-weight: bold;
  display: flex;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid #000;

  /* background-color: aqua; */
}
</style>
